import { useGetAllBrands } from "src/api/client-api/brand/useGetAllBrand";
import { useOrganizationSelector } from "src/api/client-api/company/useOrganizationSelector";
import { useGetAllProductLines } from "src/api/client-api/productLines/useProductLines";

type UseOrganizationSectionVisibilityOptions = {
    currentCompanyId: number;
};

export const useOrganizationSectionVisibility = ({ currentCompanyId }: UseOrganizationSectionVisibilityOptions) => {
    const { companies = [], isLoading: isCompaniesLoading } = useOrganizationSelector({
        enabled: true,
        // Keep the probe small while still allowing the current company to be filtered out client-side.
        itemsPerPage: 2,
    });
    const {
        allBrands,
        brandCollectionState,
        isLoading: isBrandsLoading,
        refetch: refetchBrands,
    } = useGetAllBrands({ itemsPerPage: 1 });
    const { productLines = [], isLoading: isProductLinesLoading } = useGetAllProductLines({ itemsPerPage: 1 });

    const isLoading = isCompaniesLoading || isBrandsLoading || isProductLinesLoading;
    const hasSubCompanies = companies.some((company) => company.id !== currentCompanyId);
    const hasBrands = allBrands?.length !== undefined && allBrands.length > 0;
    const hasProductLines = productLines.length > 0;
    const isBrandDataUnavailable =
        brandCollectionState.status !== "success-value" && brandCollectionState.status !== "empty";

    return {
        isLoading,
        hasSubCompanies,
        hasBrands,
        hasProductLines,
        brandCollectionState,
        refetchBrands,
        shouldHide: !isLoading && !isBrandDataUnavailable && !hasSubCompanies && !hasBrands && !hasProductLines,
    };
};
